import { render, staticRenderFns } from "./widgetHref.vue?vue&type=template&id=6005bd52&scoped=true"
import script from "./widgetHref.vue?vue&type=script&lang=js"
export * from "./widgetHref.vue?vue&type=script&lang=js"
import style0 from "./widgetHref.vue?vue&type=style&index=0&id=6005bd52&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6005bd52",
  null
  
)

export default component.exports